import React from 'react'
import { connect } from 'react-redux'
import { EMPTY_CUPO } from '../../../actions/constants'
import { reduxForm } from 'redux-form'
import { FORM_CUPO } from '../../../../../config/forms'
import DialogView from '../../../../Dialogos/DialogView'
import DetalleCodigoDeCupoView from './DetalleCodigoDeCupoView'

function DetalleCodigoDeCupo (props) {
  const { confirmCallback, cancelCallback, codigoDeCupo, cpaPorCodigo } = props

  return (
    <DialogView
      confirmCallback={confirmCallback}
      cancelCallback={cancelCallback}
      title='Detalle de código de cupo'
      content={<DetalleCodigoDeCupoView
        codigoDeCupo={codigoDeCupo}
        cpaPorCodigo={cpaPorCodigo}
      />
      }
    />
  )
}

const mapStateToProps = (state) => {
  return {
    codigoDeCupo: state.cupos.codigoDeCupo,
    cpaPorCodigo: state.cupos.cpaPorCodigo
  }
}

const withRedux = connect(mapStateToProps, null)
export default withRedux(reduxForm({
  form: FORM_CUPO,
  initialValues: EMPTY_CUPO,
  enableReinitialize: true
})(DetalleCodigoDeCupo))
